"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Stack = _interopRequireDefault(require("./Stack"));
var _useSesame = _interopRequireDefault(require("@oberoninternal/travelbase-ds/hooks/useSesame"));
var _reactIntl = require("react-intl");
var _Button = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/action/Button"));
var _Modal = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/layout/Modal"));
var _ModalHeader = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/layout/ModalHeader"));
var _Body = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/primitive/Body"));
var _grid = require("@rebass/grid");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TenantContext = require("../context/TenantContext");
var _Title = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/primitive/Title"));
var _Anchor = _interopRequireDefault(require("./designsystem/Anchor"));
var _BookButton = _interopRequireDefault(require("./designsystem/BookButton"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
const getInfoLink = (info, locale, rentalUnitName, rentalUnitCode) => {
  let {
    link
  } = info;
  if (info.queryParams) {
    const searchParams = {};
    Object.keys(info.queryParams[locale]).forEach(key => {
      const value = info.queryParams?.[locale]?.[key];
      if (value) {
        searchParams[key] = encodeURIComponent(value.replace('{rentalUnitName}', `${rentalUnitName} ${`(${rentalUnitCode})`}`));
      }
    });
    link += `?${decodeURI(new URLSearchParams(searchParams).toString())}`;
  }
  return link;
};
const PlannerHelp = ({
  className,
  rentalUnitName,
  rentalUnitCode,
  brand,
  reserving,
  bookingIsValid,
  onBookingReservation,
  type
}) => {
  const {
    onClose,
    open,
    onOpen
  } = (0, _useSesame.default)();
  const {
    brandConfig
  } = (0, _TenantContext.useTenantContext)();
  const {
    0: nativeContactInfo,
    1: setNativeContactInfo
  } = (0, _react.useState)(undefined);
  (0, _react.useEffect)(() => {
    if (brand && brandConfig.contact.useNativeContactInfo) {
      setNativeContactInfo(brandConfig?.contact?.contactInfoByBrand?.[brand]);
    }
  }, [brand, brandConfig.contact?.contactInfoByBrand, brandConfig.contact.useNativeContactInfo]);
  const intl = (0, _reactIntl.useIntl)();
  return __jsx(_react.default.Fragment, null, __jsx(_Stack.default, {
    variant: "inline",
    spacing: 4,
    alignItems: "center",
    justifyContent: ['center', null, 'space-between'],
    className: className,
    mt: [4, null, 0],
    pb: [4, null, 0],
    width: [1, 'auto']
  }, brandConfig.name !== 'campercontact' && __jsx(StyledTextbutton, {
    className: "lt-s",
    onClick: onOpen
  }, __jsx(_Anchor.default, null, __jsx(_reactIntl.FormattedMessage, {
    id: "1ZbNP3",
    defaultMessage: [{
      "type": 0,
      "value": "Hulp bij het boeken?"
    }]
  })), __jsx(_Stack.default, {
    variant: "inline"
  }, !brandConfig.contact?.useNativeContactInfo ? brandConfig?.contact?.info?.map(info => __jsx(_Stack.default, {
    width: "40px",
    key: info.link
  }, info.icon)) : nativeContactInfo?.map(info => __jsx(_Stack.default, {
    width: "40px",
    key: info.link
  }, info.icon)))), __jsx(_Button.default, {
    className: "gt-s",
    variant: "outline",
    onClick: onOpen
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "unOm4Y",
    defaultMessage: [{
      "type": 0,
      "value": "Contact opnemen"
    }]
  })), __jsx(_BookButton.default, {
    submitting: reserving,
    disabled: !bookingIsValid,
    onClick: onBookingReservation,
    "data-cy": "bookingButton"
  }, type === 'unit' && bookingIsValid && __jsx(_reactIntl.FormattedMessage, {
    id: "tHmTKn",
    defaultMessage: [{
      "type": 0,
      "value": "Reserveren"
    }]
  }), type === 'unit' && !bookingIsValid && __jsx(_reactIntl.FormattedMessage, {
    id: "ELaDA0",
    defaultMessage: [{
      "type": 0,
      "value": "Kies datum"
    }]
  }), type === 'accommodation' && __jsx(_reactIntl.FormattedMessage, {
    id: "+YEsel",
    defaultMessage: [{
      "type": 0,
      "value": "Kies een verblijf"
    }]
  }))), __jsx(_Modal.default, {
    onClose: onClose,
    open: open,
    variant: "regular"
  }, __jsx(_ModalHeader.default, {
    variant: "small"
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "+uGiQn",
    defaultMessage: [{
      "type": 0,
      "value": "Contact informatie"
    }]
  })), !brandConfig.contact?.useNativeContactInfo ? brandConfig.contact?.info?.map(info => __jsx(ContactBlock, {
    href: getInfoLink(info, intl.locale, rentalUnitName ?? '', rentalUnitCode ?? ''),
    key: info.link,
    target: "_blank"
  }, __jsx(StyledRow, {
    flexDirection: "row"
  }, __jsx(StyledIconBox, {
    mr: [4, 3]
  }, info.icon), __jsx(_grid.Box, null, __jsx(_Title.default, null, info.name), __jsx(StyledBody, null, info.content))))) : nativeContactInfo?.map(info => __jsx(ContactBlock, {
    href: getInfoLink(info, intl.locale, rentalUnitName ?? '', rentalUnitCode ?? ''),
    key: info.link,
    target: "_blank"
  }, __jsx(StyledRow, {
    flexDirection: "row"
  }, __jsx(StyledIconBox, {
    mr: [4, 3]
  }, info.icon), __jsx(_grid.Box, null, __jsx(_Title.default, null, info.name), __jsx(StyledBody, null, info.content)))))));
};
const StyledRow = (0, _styledComponents.default)(_grid.Flex).withConfig({
  displayName: "PlannerHelp__StyledRow",
  componentId: "sc-1yo001d-0"
})(["padding:24px;"]);
const StyledTextbutton = (0, _styledComponents.default)(_grid.Flex).withConfig({
  displayName: "PlannerHelp__StyledTextbutton",
  componentId: "sc-1yo001d-1"
})(["width:100%;justify-content:space-between;"]);
const ContactBlock = _styledComponents.default.a.withConfig({
  displayName: "PlannerHelp__ContactBlock",
  componentId: "sc-1yo001d-2"
})(["border:1px solid ", ";display:flex;flex-direction:column;border-radius:0.6rem;text-decoration:none;color:inherit;margin-top:0.8rem;margin-bottom:0.8rem;&:visited{text-decoration:none;color:inherit;}"], ({
  theme
}) => theme.colors.neutral['20']);
const StyledIconBox = (0, _styledComponents.default)(_grid.Box).withConfig({
  displayName: "PlannerHelp__StyledIconBox",
  componentId: "sc-1yo001d-3"
})(["max-width:3.2rem;svg{margin-right:1.6rem;@media screen and (min-width:", "){width:3.2rem;height:3.2rem;}width:32px;height:32px;}"], ({
  theme
}) => theme.mediaQueries.l);
const StyledBody = (0, _styledComponents.default)(_Body.default).withConfig({
  displayName: "PlannerHelp__StyledBody",
  componentId: "sc-1yo001d-4"
})(["line-height:1.5;margin-bottom:0.8rem;@media screen and (min-width:", "){min-height:5.6rem;margin-bottom:1.6rem;}"], ({
  theme
}) => theme.mediaQueries.l);
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(PlannerHelp);